import React, { useState } from "react";
import Helpers from "../../../../../../helpers/helpers";
import moment from "moment";
import Styled from "./InvoiceEntry.styles";
import l10n from "../../../../../../localization";
import { IconPdf } from "../../../../../../components/Icons/Icons";
import { Tooltip } from "reactstrap";

export default ({ invoice, gatewayWSPAYForm, onOpenInvoice }) => {
  const [metersVisible, setMetersVisible] = useState(false);
  const [reversedTooltipOpened, setReversedTooltipOpened] = useState(false);
  const [enforcementTooltipOpened, setEnforcementTooltipOpened] = useState(
    false
  );

  return (
    <React.Fragment>
      <Styled.InvoiceWrapper
        key={invoice.invoiceId}
        cursorVisible={invoice.meters && invoice.meters.length > 0}
        onClick={() => {
          if (invoice.meters && invoice.meters.length > 0)
            setMetersVisible(!metersVisible);
        }}
      >
        <Styled.IsReversed>
          {invoice.isReversed && (
            <>
              <span id={`reversedLabel_${invoice.invoiceId}`}>S</span>
              <Tooltip
                placement="top"
                isOpen={reversedTooltipOpened}
                target={`reversedLabel_${invoice.invoiceId}`}
                toggle={() => setReversedTooltipOpened(!reversedTooltipOpened)}
              >
                {l10n.einvoice.isReversed}
              </Tooltip>
            </>
          )}
          {invoice.isEnforcement && (
            <>
              <span id={`enforcementLabel_${invoice.invoiceId}`}>O</span>
              <Tooltip
                placement="top"
                isOpen={enforcementTooltipOpened}
                target={`enforcementLabel_${invoice.invoiceId}`}
                toggle={() =>
                  setEnforcementTooltipOpened(!enforcementTooltipOpened)
                }
              >
                {l10n.einvoice.isEnforcement}
              </Tooltip>
            </>
          )}
        </Styled.IsReversed>

        <td>{invoice.invoiceAddress}</td>
        <td className="weight-medium">{invoice.invoiceNumber}</td>
        <td>{invoice.invoiceType}</td>
        <td>
          {invoice.period ? moment(invoice.period).format("MM.YYYY") : "-"}
        </td>
        <td>{moment(invoice.invoiceIssueDate).format("DD.MM.YYYY")}</td>
        <td>{invoice.invoiceExpirationDate ? moment(invoice.invoiceExpirationDate).format("DD.MM.YYYY") : "-"}</td>
        <td>
          <strong>{Helpers.formatPrice(invoice.invoiceValue)}</strong>
        </td>
        <Styled.PriceWrapper>
          <strong>{Helpers.formatPrice(invoice.invoiceBalance)}</strong>
        </Styled.PriceWrapper>
        <Styled.PriceWrapper negative={true}>
          <strong>{Helpers.formatPrice(invoice.invoiceDebt)}</strong>
        </Styled.PriceWrapper>
        <td>
          <div
            onClick={(e) => {
              e.stopPropagation();
              onOpenInvoice(invoice.invoiceId);
            }}
          >
            <IconPdf></IconPdf>
          </div>
        </td>
        {/* <td>{gatewayWSPAYForm(invoice)}</td> */}
      </Styled.InvoiceWrapper>

      <Styled.MetersRow visible={metersVisible}>
        <td colSpan="10">
          <table>
            <thead>
              <tr>
                <td>{l10n.invoices.meterSiteCode}</td>
                <td>{l10n.invoices.meterCode}</td>
                <td>{l10n.invoices.readingDate}</td>
                <td>{l10n.invoices.reading}</td>
                <td>{l10n.invoices.lastReading}</td>
                <td>{l10n.invoices.consumption}</td>
                <td>{l10n.invoices.deducedVolume}</td>
                <td>{l10n.invoices.addedVolume}</td>
                <td>{l10n.invoices.remainingVolume}</td>
              </tr>
            </thead>
            <tbody>
              {(invoice.meters || []).map((meter) => (
                <tr key={`${meter.meterSiteCode}_${meter.meterCode}`}>
                  <td>{meter.meterSiteCode}</td>
                  <td>{meter.meterCode}</td>
                  <td>{moment(meter.readingDate).format("DD.MM.YYYY")}</td>
                  <td>{Helpers.formatNumber(meter.reading)}</td>
                  <td>{Helpers.formatNumber(meter.lastReading)}</td>
                  <td>{Helpers.formatNumber(meter.consumption)}</td>
                  <td>{Helpers.formatNumber(meter.deductedVolume)}</td>
                  <td>{Helpers.formatNumber(meter.addedVolume)}</td>
                  <td>{Helpers.formatNumber(meter.remainingVolume)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </td>
      </Styled.MetersRow>
    </React.Fragment>
  );
};
